import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAlarmAddComponent } from "./med-icon-alarm-add.component";

@NgModule({
  declarations: [
    MedIconAlarmAddComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAlarmAddComponent,
  ],
})
export class MedIconAlarmAddModule { }
